module.exports = __webpack_public_path__ + "img/p-one-step-19.df44c91f.png";